// import { service, request } from "@/utils/request"
import { request } from "@/utils/request"
import api from "@/services/api"

let hashMap1 = {
  sea: {},
  electric: {},
}

const regionMap = {}  // 地区id与name键值匹配表

let regionList = [] // 区域的全部列表

const regionName = {  // 地区名称列表
  global: [],
  domestic: []
}

const hashMap = {
  sea: {
    1: "新闻",
    2: "政策法规",
    3: "理论",
    4: "技术",
    5: "产品",
    6: "行业应用",
    7: "人才培养",
    1_1: "军事",
    1_2: "民用",
    1_3: "军民融合",
    2_1: "海洋开发",
    2_2: "海洋管理",
    2_3: "海洋理念",
    2_4: "海洋产业发展",
    3_1: "海洋信息",
    3_2: "数字海洋",
    3_3: "海洋数据",
    3_4: "海洋资料",
    4_1: "信息感知领域",
    4_2: "信息传输领域",
    4_3: "信息处理领域",
    4_4: "信息应用领域",
    5_1: "天",
    5_2: "空",
    5_3: "岸",
    5_4: "海",
    5_5: "潜",
    6_1: "海洋渔业",
    6_2: "海洋汽油业",
    6_3: "海洋矿业",
    6_4: "海洋盐业",
    6_6: "海洋生物医药业",
    6_5: "海洋化工业",
    6_7: "海洋电力业",
    6_8: "海洋利用业",
    6_9: "海洋船舶工业",
    6_10: "海洋工程建筑业",
    6_11: "海洋交通运输业",
    6_12: "滨海旅游业",
    6_13: "海洋科研教育管理服务业",
    6_14: "海洋相关产业",
    7_1: "海洋基础科学",
    7_2: "海洋工程技术",
    7_3: "海洋信息服务",
    7_4: "海洋技术服务",
  },
  electric: {
    1: "新闻",
    2: "理论",
    3: "技术",
    4: "产品",
    5: "人才培养",
    3_1: "防空预警探测",
    3_2: "反导预警探测领域",
    3_3: "空间目标监视领域",
    3_4: "天基雷达",
    3_5: "舰载雷达",
    3_6: "机载雷达",
    3_7: "陆军电子对抗",
    3_8: "舰载电子对抗",
    3_9: "机载电子对抗",
    3_10: "电磁空间管控",
    4_1: "防空预警探测",
    4_2: "反导预警探测领域",
    4_3: "空间目标监视领域",
    4_4: "天基雷达",
    4_5: "舰载雷达",
    4_6: "机载雷达",
    4_7: "陆军电子对抗",
    4_8: "舰载电子对抗",
    4_9: "机载电子对抗",
    4_10: "电磁空间管控",
    5_1: "高校",
    5_2: "研究院所",
    5_3: "公司",
    5_4: "军队",
  },
}

const regionValue = {
  // 各区域总数
  global: [],
  domestic: [],
  range: {
    global: [0, -Infinity], // 国内区域值的范围
    domestic: [0, -Infinity], // 国内区域值的范围
  },
}

/**
 * 获取后端mock数据
 */
// const getServiceData = function () {
//   return service.api
// }

/**
 * 获取117后端真实数据, 二次封装
 */
const getRequestData = function () {
  return request
}

/**
 * pushHashMap 处理后端数据，保存入hashMap，用于Information的匹配
 * v是当前遍历，type是sea/ electric
 */
const pushHashMap = function (v, type) {
  let codeArr = v.code.split("."),
    code = ""
  if (!codeArr[1]) {
    // 一级菜单 '1.'
    code = codeArr[0]
  } else {
    code = codeArr[0] + "_" + codeArr[1]
  }
  hashMap1[type][code] = v.name
}

/**
 * getCategoryList 获取hashmap表
 * @param {*} v
 * @param {*} typeObj
 * @param {*} systemType
 * @returns
 */
const getCategoryList = function (page_size = 100, page_to = 1) {
  // 请求后端Categories接口
  // getRequestData()
  //   .categories.find("", {
  //     page_size: 100,
  //     page_to: 1,
  //   })
  api.categories.list({ page_size, page_to }).response
    .then((res) => {
      if (!res.data.data.records) {
        // 请求失败
        hashMap1 = hashMap
        console.error("请求后端Categories接口失败，使用本地数据")
        return
      }
      res.data.data.records.map((v) => {
        if (v.domain_id === 1) {
          // 海洋信息
          pushHashMap(v, "sea")
        } else if (v.domain_id === 2) {
          pushHashMap(v, "electric")
        }
      })
      // console.log(hashMap1, "请求后端Categories接口")
    })
}

/**
 * getRegionMap 获取地区的hashMap，id与name匹配
 * @param {*} v
 * @returns regionMap 地区id和name匹配表
 */
const getRegionMap = function (page_size = 300, page_to = 1) {
  return new Promise(resolve => {
    // getRequestData()
    // .regions.find("", {
    //   page_size: 300,
    //   page_to: 1,
    // })
    api.regions.list({ page_size, page_to }).response
      .then((res) => {
        if (!res.data.data.records) {
          console.error("Regions接口请求失败")
          return
        }

        regionList = JSON.parse(JSON.stringify(res.data.data.records))

        res.data.data.records.map((v) => {
          // 存放id,name的键值表
          regionMap[v.id] = v.name
          regionMap[v.name] = v.id

          // 存放地区名称列表
          if (v.parent_id) {  // 通过parent_id是否为null, 判断国内还是国外
            regionName.domestic.push(v.name)
          } else {
            regionName.global.push(v.name)
          }
        })
        resolve(true)
        return regionMap
      })
  })
  // getRequestData()
  // .regions.find("", {
  //   page_size: 300,
  //   page_to: 1,
  // })
  // .then((res) => {
  //   if (!res.data.data.records) {
  //     console.error("Regions接口请求失败")
  //     return
  //   }
  //   res.data.data.records.map((v) => {
  //     regionMap[v.id] = v.name
  //     regionMap[v.name] = v.id
  //   })
  //   return regionMap
  // })
}

/**
 * 处理当前数据的公共方法，根据系统名称推入对应的数组
 * @param {*} v 当前遍历的值
 */
const mapData = function (v, typeObj, systemType) {
  if (!typeObj[v.region]) {
    typeObj[v.region] = [] // 初始化该地区
  }

  let categ = v.category_code.split(".")
  let obj = {
    region: v.region,
    domain: v.domain,
    datetime: v.datetime.split("T")[0],
    content: v.content,
    category: hashMap1[systemType][categ[0]],
    categoryCode: v.category_code,
    categoryName: hashMap1[systemType][categ[0]],
    quantity: v.quantity,
    title: v.title,
    link: v.link,
    unit: v.unit || ''//单位
  }
  if (categ[1] && hashMap1[systemType][String(categ[0]) + "_" + String(categ[1])]) {
    // 存在二级分类
    obj.categorySubName = hashMap1[systemType][String(categ[0]) + "_" + String(categ[1])]
    obj.category += "-" + obj.categorySubName
    if (categ[0] == 2) {
      // console.log(obj) 888888888888888888888888888888888888888
      // debugger
    }
  }
  typeObj[v.region].push(obj)
  return typeObj
}

/**
 * saveAllInformation 将后端拿到的AllInformation数据缓存入store
 * @param {*} _this
 */
// const saveAllInformation = function (data, _this) {
//   const sea = {},
//     electric = {}

//   // 以国家为key，value为数组，将domain=海洋信息的，push入sea, map完赋值给regionInformation[systemType], 类别用hashmap匹配
//   data.map((v) => {
//     if (v.domain === "海洋信息") {
//       mapData(v, sea, "sea")
//     } else {
//       // 信息空间
//       mapData(v, electric, "electric")
//     }
//   })

//   // 存入store， 可优化， 请求domain接口，解耦合 todo
//   _this.$store.commit("setRegionInformation", {
//     海洋信息: sea,
//     电磁空间: electric,
//   })
// }

const processData = function (data) {
  const sea = {},
    electric = {}
  // 以国家为key，value为数组，将domain=海洋信息的，push入sea, map完赋值给regionInformation[systemType], 类别用hashmap匹配
  data.map((v) => {
    if (v.domain === "海洋信息") {
      mapData(v, sea, "sea")
    } else {
      // 信息空间
      mapData(v, electric, "electric")
    }
  })
  return {
    海洋信息: sea,
    电磁空间: electric,
  }
}

const doSaveData = function (_this, data) {
  _this.$store.commit("setRegionInformation", data)
}

/**
 * getAllInformation mock, 当vuex中不存在时请求一遍所有数据，并存入vuex
 * @param {*} _this vue示例
 */
// const getAllInformation = function (_this) {
//   getServiceData()
//     .find("information")
//     .then((res) => {
//       // _this.$store.commit("setAllInformationList", res)
//       console.log("拿到后端所有数据", res.data)

//       saveAllInformation(res.data, _this)
//     })
// }

/**
 * changeMockFormat 将真实数据格式处理成与mock相同的格式
 * @param {*} v 遍历到的值
 * @param {*} res 原数组
 */
const changeMockFormat = function (v, region) {
  v.datetime = v.information.the_time
  v.region = region // 这里有多个需要向原数组中加入
  v.category_code = v.information.category.code
  v.category_id = v.information.category.id
  v.link = v.information.link
  v.title = v.information.title
  v.quantity = v.information.quantity
  v.category = v.information.category.name
  v.domain = v.information.domain.name
  v.content = v.information.content
  v.unit = v.information.unit
  // let recordsLen = v.information.region_ids.length
  // if (recordsLen > 1) {
  //   for (let i = 1; i < recordsLen; i++) {
  //     // 从1开始
  //     res.data.data.records.push({
  //       category: v.information.category,
  //       category_code: v.information.category.code,
  //       category_id: v.information.category.id,
  //       content: v.information.content,
  //       datetime: v.information.the_time,
  //       quantity: v.information.quantity,
  //       region: regionMap[v.information.region_ids[i]],
  //       title: v.information.title,
  //       domain: v.information.domain.name,
  //       link: v.information.link,
  //     })
  //   }
  // }
  delete v.information
}

/**
 * getRealAllInformation 真实数据, 当vuex中不存在时请求一遍所有数据，并存入vuex
 * 这里处理成与mock相同格式的数据
 * @param {*} _this vue示例
 */
const getRealAllInformation = function (_this, region, is_domestic) {
  return new Promise(resolve => {
    // getRequestData()
    // .region_information.find("", {
    //   page_size: 20000, // 限制获取条数, 总共多少条数据
    //   // page_to: 1,
    //   is_domestic: is_domestic,
    //   region_id: regionMap[region],
    // })
    api.region_information.list({
      page_size: 20000, // 限制获取条数, 总共多少条数据
      // page_to: 1,
      is_domestic: is_domestic,
      region_id: regionMap[region],
    }).response
      .then((res) => {
        res.data.data.records.map((v) => {
          changeMockFormat(v, region)
        })

        // _this.$store.commit("setAllInformationList", res)
        // console.log("拿到后端所有数据", res.data.data.records)
        // saveAllInformation(res.data.data.records, _this)
        const result = processData(res.data.data.records)
        doSaveData(_this, result)

        _this.isLoading = false
        resolve(result)
      })
  })

}

/**
 * postSummarizeList 获取地图上区域的对应值
 * @param {*} is_domestic 是否为国内
 * @param {*} type global/ domestic
 */
const postSummarizeList = async function (is_domestic, domain_id, type) {
  // getRequestData()
  //   .mapSummarize.create({22
  //     is_domestic,
  //     domain_id
  //   })
  //初始化regionValue
  regionValue.global.length = 0
  regionValue.domestic.length = 0
  regionValue.range = {
    global: [0, -Infinity], // 国内区域值的范围
    domestic: [0, -Infinity], // 国内区域值的范围
  }


  const res = await api.region_information.summarize({ is_domestic, domain_id }).response
  // .then((res) => {
  res.data.data.map((v) => {
    regionValue[type].push({
      name: regionMap[v.region_id],
      value: v.value,
      region_id: v.region_id
    })
    // regionValue.range[type][0] = Math.min(regionValue.range[type][0], v.value)
    regionValue.range[type][1] = Math.max(regionValue.range[type][1], v.value)
  })

  const regionLen = regionValue[type].length

  for (let i = 0; i < regionList.length; i++) {
    let flag = 0  // 是否包含
    if (regionList[i].parent_id === null && type == 'domestic') {
      continue
    } else if (regionList[i].parent_id !== null && type == 'global') {
      continue
    }

    for (let j = 0; j < regionLen; j++) {
      if (regionValue[type].region_id === regionList[i].id) {
        flag = 1
        break     // 包含，直接下一个 
      }
    }

    if (!flag) regionValue[type].push({
      name: regionList[i].name,
      value: 0,
      region_id: regionList[i].id
    })
  }

  // })
}

/**
 * 获取领域id信息
 * @returns
 */

const getDomainsId = async function () {
  // const {data} = await request.domains_id.find("", {
  //   page_size: 15,
  //   page_to: 1,
  // })
  const { data } = await api.domains.list({ page_size: 15, page_to: 1 }).response
  const domainMap = new Map()
  data.data.records.forEach(domain => {
    domainMap.set(domain.name, domain.id)
  })
  return domainMap
}

/**
 * initData 对所有后端数据初始化，通过hashMap表，得到AllInformation，存入vuex
 * @param {*} _this vue示例
 */
const initData = async function (_this, region, is_domestic) {
  // 如果存在regionValue，则跳过
  if (!_this.$store.getters.getRegionValue) {
    // 获取hashmap表
    getCategoryList()

    // 获取地区hashMap
    await getRegionMap()

    //获取当前领域id
    const domainMap = await getDomainsId()
    _this.$store.commit("setDomainMap", domainMap)

    const domain_id = domainMap.get(_this.$store.state.systemType)
    // 获取地图上区域的对应值, 并存入vuex
    postSummarizeList(1, domain_id, "domestic") // is_domestic 国内
    postSummarizeList(0, domain_id, "global") // is_domestic 国外
    console.log(regionValue)
    _this.$store.commit("setRegionValue", regionValue)
    _this.$store.commit("setRegionMap", regionMap)
    _this.$store.commit("setRegionNameList", regionName)
    _this.regionMap = regionMap
  }
  // 为null则请求一遍allInformation, 存入vuex
  // getAllInformation(_this)
  const processedData = await getRealAllInformation(_this, region, is_domestic)
  return processedData
}


/**
 * 更新地图各区域数据
 * @param {Vue} _this vue实例 
 * @param {string} systemType 领域类型
 * @returns {object}
 */
const updateRegionValue = async (_this, systemType) => {
  const domain_id = _this.$store.state.domainMap.get(systemType)
  // 获取地图上区域的对应值, 并存入vuex
  postSummarizeList(1, domain_id, "domestic") // is_domestic 国内
  await postSummarizeList(0, domain_id, "global") // is_domestic 国外
  _this.$store.commit("setRegionValue", regionValue)
  return regionValue
}

export { initData, getRequestData, getRealAllInformation, updateRegionValue }
